import Highway from "@dogstudio/highway"
import gsap from "gsap"
import { classesInjection } from "../utils/transitions"

const durationOut = 0.3
const durationIn = 0.75
const easeIn = "power2.inOut"
const easeOut = "power2.inOut"

export const x = 24
export const y = 10

class CurtainsTransition extends Highway.Transition {
  constructor(options) {
    super(options)
    this.leftCurtain = document.querySelector("[data-curtain-left]")
    this.rightCurtain = document.querySelector("[data-curtain-right]")
    this.debugMode = true
  }

  debugLog(message) {
    if (this.debugMode) {
      console.log(`[CurtainsTransition] ${message}`)
    }
  }


  checkMobile() {
    return window.innerWidth < 1024 // lg breakpoint
  }
  in({ from, to, done }) {
    classesInjection(to)

    from.remove()

    const isMobile = this.checkMobile()
    const timeline = gsap.timeline({
      onComplete: () => {
        this.debugLog("in → done")
        done()
      },
    })

    timeline.to({}, { duration: 0.3 })

    if (isMobile) {
      // Mobile: animate Y (top curtain down, bottom curtain up)
      timeline
        .to(this.leftCurtain, {
          y: window.innerHeight / 2,
          duration: durationIn,
          ease: easeIn,
        }, 0)
        .to(this.rightCurtain, {
          y: -window.innerHeight / 2,
          duration: durationIn,
          ease: easeIn,
        }, 0)
    } else {
      // Desktop: animate X (left curtain right, right curtain left)
      timeline
        .to(
          this.leftCurtain,
          {
            x: window.innerWidth / 2,
            duration: durationIn,
            ease: easeIn,
          },
          0
        )
        .to(
          this.rightCurtain,
          {
            x: -window.innerWidth / 2,
            duration: durationIn,
            ease: easeIn,
          },
          0
        )
    }

    return this
  }

  out({ from, done }) {
    const isMobile = this.checkMobile()
    const timeline = gsap.timeline({
      onComplete: () => {
        this.debugLog("out → done")
        done()
      },
    })

    timeline.to('main', {
      opacity: 0,
      duration: durationOut,
      ease: easeOut,
    }, 0)

    if (isMobile) {
      timeline
        .to(this.leftCurtain, {
          y: 0,
          duration: durationOut,
          ease: easeOut,
        }, 0)
        .to(this.rightCurtain, {
          y: 0,
          duration: durationOut,
          ease: easeOut,
        }, 0)
    } else {
      timeline
        .to(
          this.leftCurtain,
          {
            x: 0,
            duration: durationOut,
            ease: easeOut,
          },
          0
        )
        .to(
          this.rightCurtain,
          {
            x: 0,
            duration: durationOut,
            ease: easeOut,
          },
          0
        )
    }

    return this
  }
}

export default CurtainsTransition
